import { render } from "./SubscriptionPageServiceParameter.vue?vue&type=template&id=35d19c4a"
import script from "./SubscriptionPageServiceParameter.vue?vue&type=script&lang=ts"
export * from "./SubscriptionPageServiceParameter.vue?vue&type=script&lang=ts"
script.render = render

export default script